import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true, headers: { "X-TM-Client": "web" } });

let onUnauthorized = () => {};
let onAupRequired = () => {};
export const setAuthHandlers = (unauth, aup) => {
  onUnauthorized = unauth;
  onAupRequired = aup;
};

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const s = err.response?.status;
    const url = err.config?.url || "";
    if (s === 401 && !url.includes("/auth/otp") && !url.includes("/restore")) onUnauthorized(err.response?.data?.detail);
    if (s === 403 && err.response?.data?.detail === "AUP_REQUIRED") onAupRequired();
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Si è verificato un errore";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export async function downloadFile(url, filename) {
  const r = await api.get(url, { responseType: "blob" });
  const href = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = href;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(href);
}

export const fmtDate = (v) => (v ? new Date(v).toLocaleDateString("it-IT") : "—");
export const fmtDateTime = (v) => (v ? new Date(v).toLocaleString("it-IT") : "—");
export const fmtMoney = (v) =>
  v === undefined || v === null || v === "" ? "—" : Number(v).toLocaleString("it-IT", { style: "currency", currency: "EUR" });
